<div class="toro-asset-status-icon-container">
    <div *ngIf="isCircle" class="toro-asset-status-icon circle" [ngStyle]="{'background-color': color}"></div>
    <div *ngIf="isOff" class="toro-asset-status-icon asset-status off"><div class="off-inner"></div></div>
    <div *ngIf="isNeedsAttention"><img class="toro-asset-status-icon broken" src="../../../../../../assets/images/asset-tracking/alert.png" /></div>
    <div *ngIf="isNotUsed" class="toro-asset-status-icon"><fa-icon icon="times"></fa-icon></div>
    <div *ngIf="isUnavailable" class="toro-asset-status-icon"><fa-icon icon="minus-circle"></fa-icon></div>
    <div class="toro-asset-status-label">{{label | translate}}</div>
</div>
